export const EVENTS = {
  inviteToApplyBanner: 'profile_invite_to_apply_banner',
  inviteToApply: 'profile_invite_to_apply',
  updateIntroProfileVisibility: 'profile_update_intro_profile_visibility',
  updatePrivacySettingsBanner: 'profile_update_privacy_settings_banner',
  shareProfile: 'profile_share_profile',
  copyShareLink: 'profile_copy_share_link',
  sharePublicProfileDialog: 'profile_share_public_profile_dialog',
  educationHistoryBrowseProfessionalCertificates: 'profile_education_history_browse_professional_certificates',
  openHighlightsCertificateItem: 'profile_open_highlights_certificate_item',
  openEducationHistoryBadgeItem: 'profile_open_education_history_badge_item',
  openEducationHistoryCertificateItem: 'profile_open_education_history_certificate_item',
  credentialSkillTagsShowMore: 'profile_credential_skill_tags_show_more',
  credentialSkillTagsShowLess: 'profile_credential_skill_tags_show_less',
  addWebsiteLink: 'profile_add_website_link',
  openExternalLink: 'profile_open_external_link',
  removeTalentPipelineWorkPreferences: 'profile_remove_talent_pipeline_work_preferences',
  closeOnboardingStepperJoinedDialog: 'profile_close_onboarding_stepper_joined_dialog',
  undoOnboardingStepperJoinedDialog: 'profile_undo_onboarding_stepper_joined_dialog',
  joinNowOnboardingStepper: 'profile_join_now_onboarding_stepper',
  joinNowOnboardingStepperV2: 'profile_join_now_onboarding_stepper_v2',
  shareOnboardingStepper: 'profile_share_onboarding_stepper',
  shareOnboardingStepperRecruiter: 'profile_share_onboarding_stepper_recruiter',
  onboardingStepperCollapseOpen: 'profile_onboarding_stepper_collapse_open',
  onboardingStepperCollapseClose: 'profile_onboarding_stepper_collapse_close',
  onboardingStepperWorkPreferences: 'profile_onboarding_stepper_work_preferences',
  onboardingStepperEditIntro: 'profile_onboarding_stepper_edit_intro',
  onboardingStepperAddEducation: 'profile_onboarding_stepper_add_education',
  onboardingStepperWorkExperience: 'profile_onboarding_stepper_work_experience',
  onboardingV2StepperWorkPreferences: 'profile_onboarding_v2_stepper_work_preferences',
  onboardingV2StepperEditIntro: 'profile_onboarding_v2_stepper_edit_intro',
  onboardingV2StepperAddJobRelevantProjects: 'profile_onboarding_v2_stepper_add_job_relevant_projects',
  onboardingV2StepperLinksResume: 'profile_onboarding_v2_stepper_links_resume',
  onboardingV2StepperWorkExperience: 'profile_onboarding_v2_stepper_work_experience',
  onboardingV2StepperCollapseOpen: 'profile_onboarding_v2_stepper_collapse_open',
  onboardingV2StepperCollapseClose: 'profile_onboarding_v2_stepper_collapse_close',
  profileBrowseProjects: 'profile_browse_projects',
  profileBrowseProjectsDialog: 'profile_browse_projects_dialog',
  browseProjectsFilterChip: 'browse_projects_filter_chip',
  profileBrowseProjectSelectProject: 'profile_browse_project_select_project',
  profileShowAllProjects: 'profile_show_all_projects',
  profileAddProject: 'profile_add_project',
  profileEditProject: 'profile_edit_project',
  profileProjectShowMoreSkills: 'profile_project_show_more_skills',
  profileViewProjectDetails: 'profile_view_project_details',
  profileProjectsInformationTooltip: 'profile_projects_information_tooltip',
  profileProjectArtifactLink: 'profile_project_artifact_link',
  notFoundRecruiter: 'profile_not_found_recruiter',
  notFoundPrivate: 'profile_not_found_private',
  profileCHSBannerDismiss: 'profile_chs_banner_dismiss',
  profileCHSBannerJoin: 'profile_chs_banner_join',
  profileJoinCHSDialogCancel: 'profile_join_chs_dialog_join_now',
  profileJoinCHSDialogJoinNow: 'profile_join_chs_dialog_cancel',
  portfolioViewProjectsDialog: 'portfolio_view_projects_dialog',
  portfolioCompletedProjectDialogEdit: 'portfolio_completed_project_dialog_edit',
  portfolioCompletedProjectDialogView: 'portfolio_completed_project_dialog_view',
  portfolioCompletedProjectDialogAdd: 'portfolio_completed_project_dialog_add',
} as const;
